import React, { useContext } from "react";
import CurrentQuestionContext from "../../contexts/CurrentQuestionContext";
import { Container, Link, Text } from "./alreadyAnswered.styles";
import ReactGA from "react-ga";

const AlreadyAnswered = () => {
  const subtitle = useContext(CurrentQuestionContext).question.subtitle;
  const btnText = useContext(CurrentQuestionContext).question.btnText;
  const btnLinkUrl = useContext(CurrentQuestionContext).question.btnLinkUrl;
  const btnColor = useContext(CurrentQuestionContext).question.btnColor;
  const btnHoverColor = useContext(CurrentQuestionContext).question
    .btnHoverColor;

  const onUserClick = () => {
    ReactGA.event({
      category: "reference",
      action: "tapped_reference",
      label: "hamadad",
    });
    window.open(btnLinkUrl);
  };

  return (
    <Container>
      <Text>{subtitle}</Text>
      <Link
        onClick={onUserClick}
        btnColor={btnColor}
        btnHoverColor={btnHoverColor}
      >
        {btnText}
      </Link>
    </Container>
  );
};

export default AlreadyAnswered;
